<script lang="ts">import LinkList from '../../../shared/LinkList/LinkList.svelte';
const { subcategory } = $props();
const subCategoryColumnsCount = subcategory.props.primaryNavItems.length - 1 || 1; // first column stacks 2 items
// Split the subcategory into two groups
// First two items take up the first column
const firstColumnItems = subcategory.props.primaryNavItems.slice(0, 2);
// All other items, each take up one column
const remainingItems = subcategory.props.primaryNavItems.slice(2);
const secondColumnStartingIndex = firstColumnItems.map((item) => item.props.primaryNavItems.length).reduce((a, b) => a + b, 0) + 1;
</script>

<ul
  class="SubcategoryLinkList slide-in-from-top"
  data-entry-id={subcategory.contentfulEntryId}
  style:--subcategory-columns-count={subCategoryColumnsCount}
>
  <!-- Group the first two LinkLists into a single div for first column-->
  <li class="link-list-container first-column" style:--link-list-number={1}>
    {#each firstColumnItems as linkList, index}
      <LinkList
        id={linkList.contentfulEntryId}
        title={linkList.props.title}
        excludeTitleOnDesktop={linkList.props.excludeTitleOnDesktop}
        navItems={linkList.props.primaryNavItems}
        linkStartingIndex={firstColumnItems[index - 1]?.props?.primaryNavItems?.length + 1 || 0}
        slideInFrom="top"
      />
    {/each}
  </li>

  <!-- Render the remaining LinkLists as separate items, each take up a column-->
  {#each remainingItems as linkList, index}
    <li class="link-list-container" style:--link-list-number={index + 2}>
      <LinkList
        id={linkList.contentfulEntryId}
        title={linkList.props.title}
        excludeTitleOnDesktop={linkList.props.excludeTitleOnDesktop}
        navItems={linkList.props.primaryNavItems}
        linkStartingIndex={secondColumnStartingIndex}
        slideInFrom="top"
      />
    </li>
  {/each}
</ul>

<style>@keyframes fade-in-slide-from-top {
  from {
    opacity: 0;
    transform: translateX(0) translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
@keyframes fade-in-slide-from-left {
  from {
    opacity: 0;
    transform: translateX(-4px) translateY(0);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
@keyframes slide-down {
  from {
    transform: translateY(-50%);
  }
  to {
    transform: translateY(0);
  }
}
/**
We use rem units for media queries to promote accessible layouts. By utilizing rem units, the computed values in media queries are determined by the user's browser-defined font size rather than our global 'font-size: 62.5%' reset. This approach ensures that our design adapts to individual user settings, enhancing accessibility. 
*/
.SubcategoryLinkList {
  width: 100%;
  max-width: calc(var(--subcategory-columns-count) * 350px + (var(--subcategory-columns-count) - 1) * 20px);
  display: block;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  list-style-type: none;
  display: flex;
  align-items: flex-start;
  gap: 20px;
}
.SubcategoryLinkList > li {
  display: block;
  position: static;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
.SubcategoryLinkList > li::before {
  display: none;
}
.SubcategoryLinkList > li :global(:last-child) {
  margin: 0;
}
.SubcategoryLinkList .first-column {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.SubcategoryLinkList .link-list-container {
  width: calc((100% - (var(--subcategory-columns-count) - 1) * 20px) / var(--subcategory-columns-count));
}
.SubcategoryLinkList.slide-in-from-top .link-list-container {
  opacity: 0;
  transform: translateX(0) translateY(-4px);
  animation: fade-in-slide-from-top 300ms ease-in forwards;
  animation-delay: calc(150ms + var(--link-list-number) * 20ms);
}
.SubcategoryLinkList.slide-in-from-top .link-list-container :global(.LinkList .slide-in-from-top) {
  opacity: 0;
  transform: translateX(0) translateY(-4px);
  animation: fade-in-slide-from-top 300ms ease-in forwards;
  animation-delay: calc(150ms + var(--link-list-item-number) * 20ms);
}</style>
